import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {Outlet, useLocation} from "react-router-dom";
import {MortgageContext} from "../contexts/MortgageProvider";
import {DataStore} from "@aws-amplify/datastore";
import {useWindowSize} from "../hooks/useWindowSize";
import RatesProvider from "../contexts/RatesProvider";
import {Container} from "react-bootstrap";
import SussdBarMobile from "../ui/dashboard/SussdBarMobile";
import Alerts from "../ui/dashboard/Alerts";
import {UserMortgage} from "../../models";
import Sidebar2 from "../ui/dashboard/Sidebar2";
import SectionsProvider from "../contexts/SectionsProvider";
import FirstVisitModal from "../ui/dashboard/FirstVisitModal";
function ClientAppDashboard(props) {
    const context = useContext(MortgageContext)
    const location = useLocation();
    const [w,h] = useWindowSize()
    let lastSeenTimer
    //let setupComplete = mortgage?.applicationStage && mortgage.applicationStage!=='CALCULATE' && mortgage.applicationStage!=='SETUP'
    //let opened = setupComplete && w>=768
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen)
    }
    const saveLastSeen = async ()=>{
        if (context.mortgage.id){
            let current = await DataStore.query(UserMortgage,context.mortgage.id)
            if (current){
                DataStore.save(UserMortgage.copyOf(current, item => {
                    item.lastSeen = new Date().toISOString()
                }));
            }
        }
    }
    useEffect(()=>{
        lastSeenTimer = setInterval(()=>{
            saveLastSeen()
        },60000)
    },[])
    useEffect(()=>{
        if (w>=768){

            setSidebarOpen(true)
        }

    },[w])
    const closeSidebar = () => {
        if (w<768){
            setSidebarOpen(false)
        }
    }
    const openSidebar = () => {
        if (w<768) {
            setSidebarOpen(true)
        }
    }
    const signOutAndRedirect = async function () {
        await DataStore.stop();
        await DataStore.clear();
        props.signOut()
    }
    const sidebarState = sidebarOpen ? 'sidebar-open' : ''
    const firstVisit = true// !context.mortgage?.identityId
    return (
        <WithRates withRates={false}>
            <SussdBarMobile hamburgerHidden={false} toggleSidebar={toggleSidebar} signOut={signOutAndRedirect} sidebarOpen={sidebarOpen}/>
            <SectionsProvider mortgage={context.mortgage} sidebar={{open:openSidebar,close:closeSidebar}}>
                <Container className={`${sidebarState} d-flex`}>
                    <div className={`sidebar-container sticky-top position-sticky`}>
                        <div className={"sidebar-wrapper"}>
                            <Sidebar2 sidebar={{open:openSidebar,close:closeSidebar}}/>
                        </div>
                    </div>
                    <div className="main-container ps-md-3 ps-lg-5" >
                        <Outlet/>
                    </div>
                </Container>
                {firstVisit && (
                    <FirstVisitModal mortgage={context.mortgage}/>
                )}
            </SectionsProvider>
        </WithRates>
    );
}

function WithRates(props){
    if (props.withRates){
        return <RatesProvider>{props.children}</RatesProvider>
    }
    return props.children
}
export default ClientAppDashboard;